import React, { Component } from 'react';
import { connectionGet, connectionPut, connectionPost } from '../../utils/connection';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { inject, observer } from 'mobx-react';
import moment from 'moment';

@inject('userStore')
class TrialSchedule extends Component {
  constructor(props){
    super(props);
    this.state = {
      booking_trial:null
    }
  }

  componentDidMount(){
    let updated_obj = Object.assign({}, this.props.booking);
    if (!updated_obj.trial_date){
      updated_obj.trial_date = new Date();
    }
    this.setState({
      booking_trial:updated_obj
    });
  }

  handleInputChange = (e) => {
    let updated_obj = Object.assign({}, this.state.booking_trial);
    let value = e.target.value;
    if (e.target.type === 'checkbox'){
      if (e.target.checked){
        value = 1;
      } else {
        value = 0;
      }
    }
    updated_obj[e.target.name] = value;
    this.setState({booking_trial:updated_obj});
  }

  handleChange = (date) => {
    let updated_obj = Object.assign({}, this.state.booking_trial);
    updated_obj.trial_date = date;
    this.setState({
      booking_trial:updated_obj
    });
  }

  saveTrial = () => {
    if (this.state.booking_trial.trial_date && this.state.booking_trial.trial_date !== ''){
      let updated_obj = Object.assign({}, this.state.booking_trial);
      updated_obj.trial_date_utc = moment.utc(updated_obj.trial_date).format('YYYY-MM-DD H:mm');
      this.setState({
        booking_trial:updated_obj
      },()=>{
        this.putData();
      });
    } else {
      this.putData();
    }
  }

  putData = () => {
    connectionPut('booking-trial/' + this.props.booking.hash_id , {trial: this.state.booking_trial}, {username: this.props.userStore.token}
    ).then((res) => {
      if (res.data.errors === 0){
        alert(res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      return error;
    });
  }

  render(){
    const {booking_trial} = this.state;
    return (
      <div className="card card-bordered">
        <div className={!this.props.hideHint ? "card-body" : "card-body"}>
          {!this.props.hideHint ?
          <p className="hint">Congratulations, you are the lead artist for this event!  You should schedule and provide the preview service(s).  You may also be asked to coordinate with the other artists and be available to answer questions.</p>
          : null}
          <div className="form-groups-attached">
            <div className="form-group">
              <div className="custom-control custom-checkbox mr-3">
                <input type="checkbox" id="trial" className="custom-control-input" checked={booking_trial && booking_trial.trial_scheduled && booking_trial.trial_scheduled === 1 ? true : false} name="trial_scheduled" onChange={this.handleInputChange}/>
                <label className="custom-control-label" htmlFor="trial">Trial is Scheduled.</label>
              </div>
            </div>
            <div className={booking_trial && booking_trial.trial_scheduled && booking_trial.trial_scheduled === 1 ? "d-block pb-20" : "d-none"}>
              <div className="form-group">
                <label>Trial Comments</label>
                <textarea className="form-control" name="trial_comment" value={booking_trial && booking_trial.trial_comment ? booking_trial.trial_comment : ''} onChange={this.handleInputChange}></textarea>
              </div>
              <div className="form-group">
                <label className="d-block">Scheduled Date</label>
                {booking_trial &&  booking_trial.trial_date ? (
                  <DatePicker
                    className="form-control"
                    selected={moment(booking_trial.trial_date, moment.ISO_8601).toDate()}
                    onChange={this.handleChange}
                    showTimeSelect
                    timeIntervals={5}
                    timeCaption="Time"
                    dateFormat="MMMM d, yyyy h:mm aa"
                  />
                ) : <span>Loading...</span>}
              </div>
            </div>
          </div>
        </div>
        <footer className="card-footer text-right">
          <button className="btn btn-success btn-sm" type="submit" onClick={this.saveTrial}>Save</button>
        </footer>
      </div>
    )
  }
}

export default TrialSchedule;



// WEBPACK FOOTER //
// ./src/components/business/TrialSchedule.js